import {styled} from '@core-ui/react-stitch';

const ProductGridPlaceholderWrapper = styled.div(({ isBrRedesignEnabled }) => ({
  padding: !isBrRedesignEnabled && '1rem',
}));

export default ProductGridPlaceholderWrapper;
